// extracted by mini-css-extract-plugin
export default {"markAttendanceButton":"MarkAttendanceRightWidget_markAttendanceButton__cbj9b","noCoursesAvailableSection":"MarkAttendanceRightWidget_noCoursesAvailableSection__fm2wy"};